document.addEventListener("click", function (e) {
    if (e.target && e.target.classList.contains("buy-now-btn")) {
      e.preventDefault();
      const button = e.target;
  
      // Prevent multiple clicks
      if (button.disabled) return;
  
      const variantId = button.getAttribute("data-variant-id");
      const sellingPlanId = button.getAttribute("data-selling-plan-id");
  
      // Add loading state
      button.disabled = true;
      button.classList.add("loading");
  
      fetch("/cart/clear.js", { method: "POST" })
        .then(() => {
          return fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },
            body: JSON.stringify({
              items: [
                {
                  id: variantId,
                  quantity: 1,
                  selling_plan: sellingPlanId
                }
              ]
            })
          });
        })
        .then(() => {
          window.location.href = "/checkout";
        })
        .catch((error) => {
          console.error("Buy Now failed:", error);
          button.disabled = false;
          button.classList.remove("loading");
        });
    }
  });